export function safeLocalGet(key) {
    try {
        const raw = localStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function safeLocalGetIn(key, allowed) {
    try {
        const raw = localStorage.getItem(key);
        return allowed.includes(raw) ? raw : null;
    } catch {
        return null;
    }
}

export function safeLocalSet(key, value) {
    try {
        localStorage.setItem(key, typeof value === "string" ? value : JSON.stringify(value));
    } catch {
        /* ignore */
    }
}

export function safeLocalRemove(key) {
    try {
        localStorage.removeItem(key);
    } catch {
        /* ignore */
    }
}
